// Theme colors
export const colors = {
  // Background colors
  background: {
    dark: '#1a1d20',      // Darkest background
    default: '#212529',   // Default dark background (main app background)
    modal: '#2b2f33',     // Modal background
    input: '#2b2f33'      // Input background (same as modal for consistency)
  },
  
  // Border colors
  border: {
    default: 'rgba(255, 255, 255, 0.2)',
    secondary: '#495057'
  },
  
  // Text colors
  text: {
    primary: '#fff',
    secondary: '#6c757d',
    muted: '#888'
  },
  
  // Overlay colors
  overlay: {
    default: 'rgba(0, 0, 0, 0.75)'
  },
  
  // Status colors
  status: {
    primary: '#0d6efd',
    success: '#198754',
    warning: '#ffc107',
    danger: '#dc3545'
  }
};

// Common style combinations
export const commonStyles = {
  input: {
    background: colors.background.input,
    color: colors.text.primary,
    border: `1px solid ${colors.border.secondary}`
  },
  modal: {
    background: colors.background.modal,
    border: `1px solid ${colors.border.default}`
  }
};

export default colors;
